import {
  Dropdown as FabricDropdown,
  IDropdownOption as IFabricDropdownOption,
  IDropdownProps as IFabricDropdownProps,
  ISpinnerProps,
  ISpinnerStyles,
  Spinner,
  SpinnerSize
} from 'office-ui-fabric-react';
import * as React from 'react';

import { IStyledComponent, styledComponent } from '../../../theme';
import { IConnectedComponentProps } from '../../../types';
import { PropsType } from '../../../utils/safDiagnosticSchema';

import { getDropDownSpinnerStyles } from './common.styles';

export interface IDropdownCProps extends IFabricDropdownProps {
  /** Whether to log the selected value */
  logValue: boolean;
  /** Whether the dropdown is currently loading values. */
  isLoading?: boolean;
  /** Passthrough spinner props for when `isLoading` is true */
  spinnerProps?: ISpinnerProps;
}

type ICustomDropdownProps = IStyledComponent<ISpinnerStyles> & IDropdownCProps & IConnectedComponentProps;

export class DropdownC extends React.PureComponent<ICustomDropdownProps> {
  public static defaultProps: Partial<ICustomDropdownProps> = {
    isLoading: false
  };

  public render(): React.ReactNode {
    const { onChange, onDismiss } = this.props;
    return (
      <FabricDropdown
        {...this.props}
        onChange={onChange}
        onDismiss={onDismiss}
        onRenderPlaceholder={this._onRenderDropdownPlaceholder}
      />
    );
  }

  private _onRenderDropdownPlaceholder = (
    props: IFabricDropdownProps,
    render: (props: IFabricDropdownProps) => JSX.Element
  ): JSX.Element | null => {
    // if client is overriding onRenderPlaceholder, use that instead of the custom loading behavior
    if (this.props.onRenderPlaceholder) {
      return this.props.onRenderPlaceholder(props, render);
    }

    if (this.props.isLoading) {
      return (
        <Spinner
          size={SpinnerSize.small}
          ariaLive={'polite'}
          labelPosition={'right'}
          styles={getDropDownSpinnerStyles(this.props)}
          {...this.props.spinnerProps}
        />
      );
    }

    return render(props);
  };
}

export const Dropdown = styledComponent(DropdownC, getDropDownSpinnerStyles);
export type IDropdownProps = PropsType<typeof Dropdown>;
export type IDropdownOption = IFabricDropdownOption;
